import BlockCardConfirmationDialog from './BlockCardConfirmationDialog';

export default BlockCardConfirmationDialog;